import * as QueueEffects from 'src/app/queue/store/queue.effects';
import * as reducer from 'src/app/core/store/core.reducer';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CoreEffects } from 'src/app/core/store/core.effects';
import { NetworksCrudEffects } from 'src/app/networks/store/networks-crud/networks-crud.effect';
import { NetworksEffects } from 'src/app/networks/store/networks.effects';
import { queueFeature } from 'src/app/queue/store/queue.reducer';
import { SdDatePickerA11yModule } from 'src/app/shared/sd-date-picker-a11y/sd-date-picker-a11y.module';
import { SidedrawerEffects } from 'src/app/sidedrawer/store/sidedrawer.effects';
import { SignatureEffects } from 'src/app/signature/store/signature.effects';
import {
  featureName as sideDrawerFeatureName,
  sidedrawerReducer,
} from 'src/app/sidedrawer/store/sidedrawer.reducer';
import {
  featureName as signaturesFeatureName,
  signatureReducer,
} from 'src/app/signature/store/signature.reducer';
import {
  featureName as networksFeatureName,
  networksReducer,
} from 'src/app/networks/store/networks.reducer';
import { MobileCoreRoutingModule } from './mobile-core-routing.module';
import { networkSearchFeature } from 'src/app/networks/store/network-search.store';
import { tenantPlansFeature } from 'src/app/tenant-features/store/tenant-plans.store';
import * as TenantsPlansEffects from '../../../tenant-features/store/tenant-plans.effects';
import * as NetworkSearchEffects from '../../../networks/store/network-search.effects';

// NOTE: Removed registrations of effects/reducers that dev migrated to
// SignalStore (providedIn: 'root'). Nothing else needs to be registered here:
//
//   - files: cloud-folders-files.effects, file-history.effects,
//     file-history-manage.store, files.reducer  → replaced by
//     get-file-by-id.store, file-download.store, file-delete.store,
//     file-lock.store, file-preview.store, file-sign.store,
//     record-files-global.store, search-file-history.store,
//     search-record-files.store
//   - records: records-list.effects, record-item.effects, records.reducer
//     forFeature → replaced by records-global.store, get-record-by-id.store,
//     record-delete/copy-move/lock/change-status.store, search-records.store
//   - smart-forms: smart-form-requested-list.{store,effects} → replaced by
//     smart-forms-requested-global.store, search-smart-forms-requested.store
//   - networks: network-permanent.effects → folded into networks-global.store
//   - reminders/ui-models: ReminderSignalStore, UIMStore, UIMFlowStore are now
//     providedIn: 'root' (no need to list them in providers)
//   - sd-fast-upload / sd-copy-move signal stores: providedIn: 'root'
//   - All *Service injectables previously in providers are @Injectable({
//     providedIn: 'root' }), so they self-provide.
//
// The mobile-only files/store/mobile-file-item.effects.ts depends on
// FileItemEffects (deleted) and is itself a deletion candidate; once that
// module is rewritten it can be added back here if needed.

@NgModule({
  imports: [
    MobileCoreRoutingModule,
    StoreModule.forFeature(reducer.featureName, reducer.coreReducer),
    StoreModule.forFeature(sideDrawerFeatureName, sidedrawerReducer),
    StoreModule.forFeature(networksFeatureName, networksReducer),
    StoreModule.forFeature(networkSearchFeature),
    StoreModule.forFeature(queueFeature),
    StoreModule.forFeature(signaturesFeatureName, signatureReducer),
    StoreModule.forFeature(tenantPlansFeature),
    EffectsModule.forFeature([
      CoreEffects,
      QueueEffects,
      NetworksEffects,
      NetworksCrudEffects,
      SidedrawerEffects,
      SignatureEffects,
      TenantsPlansEffects,
      NetworkSearchEffects,
    ]),
    SdDatePickerA11yModule,
  ],
})
export class MobileCoreModule {}
